<script>

export default {
  props: {
    texto: {
      type: String,
      required: false,
      default: 'Mais'
    },
    carrega: {
      type: Function,
      required: true
    },
    countPage: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    }
  }
}
</script>
<template>
  <div class="col-lg-12">
    <span @click="carrega()" class="btn btn-primary"> {{texto}} </span>
  </div>
</template>
<style scoped>
</style>



// WEBPACK FOOTER //
// carrega.vue?d526c190